/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { apiSlice } from './apiSlice';
import Seller from '../../core/models/Seller';

export const profileApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getMyProfile: builder.query<Seller, void>({
            query: () => '/sellers/my',
            providesTags: (result, error, id) => ['Profile'],
        }),
        getProfile: builder.mutation<Seller, void>({
            query: () => '/sellers/my',
        }),
        addProfile: builder.mutation<Seller, Seller>({
            query: (data) => ({
                url: '/sellers',
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Profile'],
        }),
        updateProfile: builder.mutation<Seller, Seller>({
            query: (data) => ({
                url: '/sellers',
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Profile'],
        }),
    }),
});

export const { useGetMyProfileQuery, useGetProfileMutation, useAddProfileMutation, useUpdateProfileMutation } = profileApiSlice;
